import { StyledSvg } from "baseui/icon";
import React from "react";

export const ReactRouterIcon = (props: React.ComponentProps<typeof StyledSvg>) => {
  return (
    <StyledSvg viewBox="0 0 17 17" {...props}>
      <g clipPath="url(#clip0_1449_4720)">
        <path
          d="M5.91056 9.72459C6.64244 9.72459 7.23575 9.13128 7.23575 8.3994C7.23575 7.66752 6.64244 7.07422 5.91056 7.07422C5.17868 7.07422 4.58538 7.66752 4.58538 8.3994C4.58538 9.13128 5.17868 9.72459 5.91056 9.72459ZM2.77831 12.375C3.51019 12.375 4.10349 11.7817 4.10349 11.0498C4.10349 10.3179 3.51019 9.72459 2.77831 9.72459C2.04643 9.72459 1.45312 10.3179 1.45312 11.0498C1.45312 11.7817 2.04643 12.375 2.77831 12.375ZM14.7451 12.375C15.477 12.375 16.0703 11.7817 16.0703 11.0498C16.0703 10.3179 15.477 9.72459 14.7451 9.72459C14.0132 9.72459 13.4199 10.3179 13.4199 11.0498C13.4199 11.7817 14.0132 12.375 14.7451 12.375Z"
          fill="black"
        />
        <path
          d="M10.3935 8.45671C10.3512 8.01397 10.3296 7.64547 9.99041 7.38648C9.56087 7.05848 9.07431 7.27131 8.47496 7.05498C7.88604 6.91251 7.44922 6.38962 7.44922 5.76639C7.44922 5.03354 8.0532 4.43945 8.79825 4.43945C9.35006 4.43945 9.82449 4.76534 10.0335 5.23212C10.3533 5.83963 10.1454 6.45788 10.5473 6.7693C11.0231 7.13805 11.6646 6.86801 12.3804 7.21739C12.6103 7.32308 12.805 7.4907 12.9422 7.69845C13.0794 7.9062 13.1591 8.15408 13.1591 8.42026C13.1591 9.04349 12.7222 9.56638 12.1333 9.70884C11.534 9.92518 11.0474 9.71235 10.6179 10.0404C10.1348 10.4092 10.3934 11.0262 9.99977 11.6781C9.77633 12.1073 9.32217 12.4011 8.79825 12.4011C8.0532 12.4011 7.44922 11.807 7.44922 11.0741C7.44922 10.5418 7.76794 10.0826 8.22792 9.87126C8.9437 9.52188 9.58518 9.79192 10.061 9.42317C10.3355 9.21045 10.3935 8.88229 10.3935 8.45671Z"
          fill="#D0021B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1449_4720">
          <rect width="16" height="16" fill="white" transform="translate(0.761719 0.419922)" />
        </clipPath>
      </defs>
    </StyledSvg>
  );
};
